/**
 * Sinaliza navegação full-page. O browser aborta requests em voo, que chegam ao
 * axios SEM resposta e viram NetworkError — falso-positivo de "sem conexão".
 *
 * - markNavigatingAway(): chamado SINCRONAMENTE antes do window.location.replace
 *   no redirect de login (determinístico, independe do evento de unload).
 * - pagehide: catch-all para refresh / link externo / fechar aba.
 * - pageshow: reseta ao restaurar do bfcache (back/forward).
 */
let navigatingAway = false

export const markNavigatingAway = (): void => {
  navigatingAway = true
}

export const isNavigatingAway = (): boolean => navigatingAway

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', markNavigatingAway)
  window.addEventListener('pageshow', () => {
    navigatingAway = false
  })
}
